import deepmerge from 'deepmerge';
import { FragmentConfig } from '@/config/types';
import config from './default';
import { DeepPartial } from './deeppartial';

export const tenantConfig: DeepPartial<FragmentConfig> = {
  apiParams: {
    values: {
      apiDefaultParams: {
        channel: 'web',
        clientId: 'JelmoliCh',
        clientShortId: 'jch',
        locale: 'de-CH',
        localeApi: 'de',
        localesToSwitch: ['de-CH', 'fr-CH'],
        useNewApi: true,
      },
      apiAssetManagement: {
        path: 'https://media.jelmoli-shop.ch',
      },
    },
  },
  currency: { sign: 'CHF', locale: 'fr-CH' },
  headerInformation: {
    de: {
      description:
        'Entdecken Sie aktuelle Fashion- und Wohntrends. Grosse Auswahl ✔ Top-Brands ✔ Gratis Versand & Retoure ✔ Machen Sie sich eine Freude!',
      title: 'Jelmoli Versand - der online Mode und Möbel Versand',
      canonical: 'https://www.jelmoli-shop.ch/',
      robots: 'index,follow',
    },
    fr: {
      description:
        'Entdecken Sie aktuelle Fashion- und Wohntrends. Grosse Auswahl ✔ Top-Brands ✔ Gratis Versand & Retoure ✔ Machen Sie sich eine Freude!',
      title: 'Jelmoli Versand - der online Mode und Möbel Versand',
      canonical: 'https://www.jelmoli-shop.ch/',
      robots: 'index,follow',
    },
  },
  routingPaths: {
    exact: ['/', '/fr', '/fr/'],
  },
};

export default deepmerge(config, tenantConfig) as FragmentConfig;
